package com.fireavert.events.dismiss_event.client.presentation

data class DismissEventDialogViewState(val loading: Boolean = false)
